import { attachPostRequestListener } from '../../request';
import { logoutUser } from '../actions/user/userActions';

export default ({ dispatch }) => (next) => (action) => {
  attachPostRequestListener((error) => {
    if (!error.response) {
      return Promise.reject(error);
    }

    if (error.response.status === 401) {
      return dispatch(logoutUser());
    }
    return Promise.reject(error);
  });

  next(action);
};
